/* eslint-disable */
import React from 'react';
import DataContainer from 'Components/UI/DataContainer';
import Content from './Content';
import { useAuthenticationFactorContext } from "./Context";

const AuthenticationFactorContainer = (props) => {
  const { authenticationFactorCollection, initializingError, isInitializing } = useAuthenticationFactorContext();

  return (
    <DataContainer
      component={Content}
      componentProps={{
        collection: authenticationFactorCollection,
      }}
      loading={isInitializing}
      loadingError={initializingError}
      {...props}
    />
  );
};

export default AuthenticationFactorContainer;
